// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.unsuitable-modal__content[data-v-fc777f9c] {\n  padding: 20px 30px 25px;\n}\n.unsuitable-modal__text[data-v-fc777f9c] {\n  padding-bottom: 30px;\n  font-size: 12px;\n  line-height: 1.67;\n  text-align: center;\n}\n.unsuitable-modal__btn[data-v-fc777f9c] {\n  max-width: 183px;\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
